module.exports = __webpack_public_path__ + "img/leftlogo.031fc749.png";